import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { COMMON_CHANGE_SETTINGS } from "../../../../store/Common/Common.constant";
import { updateManageMembersSettings } from "../../../../shared/services/Api/CommonService";
import AnimatedLoader from "../../../ui/animatedLoader";

const ModalManageMembersSettings = ({ show, onHide, user_id }) => {
  const dispatch = useDispatch();
  const [members, setMembers] = useState([{ email: "", join_limit: 2, no_limit: false }]);
  const [errors, setErrors] = useState([""]);
  const [isLoading, setIsLoading] = useState(false);

  // email validation
  const validateEmail = (email) => {
    if (!email) {
      return "Please enter your email address.";
    } else if (!email.includes("@")) {
      return "Missing '@' symbol in email address.";
    }
    const [localPart, domain] = email.split("@");
    if (!localPart) {
      return "Missing username before '@'.";
    }
    if (!domain) {
      return "Missing domain after '@'.";
    }
    if (!domain.includes(".")) {
      return "Domain must contain a dot (e.g., gmail.com).";
    }
    const domainParts = domain.split(".");
    if (domainParts.some((part) => part.trim() === "")) {
      return "Invalid domain structure.";
    }
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!regex.test(email)) {
      return "Invalid email format.";
    }
    return "";
  };

  // add new row for adding member
  const handleAddRow = () => {
    const lastRow = members[members.length - 1];
    const emailError = validateEmail(lastRow.email);
    if (emailError || !lastRow.join_limit) {
      const newErrors = [...errors];
      newErrors[members.length - 1] = emailError;
      setErrors(newErrors);
      return;
    }

    setMembers([...members, { email: "", join_limit: 2, no_limit: false }]);
    setErrors([...errors, ""]);
  };

  // validation to add new row
  const handleChange = (index, field, value) => {
    const updatedMembers = [...members];
    updatedMembers[index][field] = value;
    setMembers(updatedMembers);

    if (field === "email") {
      const newErrors = [...errors];
      newErrors[index] = validateEmail(value);
      setErrors(newErrors);
    }
  };

  // delete row from to add member in modal
  const handleDeleteRow = (index) => {
    setMembers(members.filter((_, i) => i !== index));
    setErrors(errors.filter((_, i) => i !== index));
  };

  // create + update
  const handleSaveMembers = async () => {
    try {
      setIsLoading(true);
      const response = await updateManageMembersSettings({
        user_id,
        members: members,
      });
      dispatch({
        type: COMMON_CHANGE_SETTINGS,
        payload: {
          user_id,
          data: {
            member_settings: {
              members: [members],
            },
          },
        },
      });
      toast.success(response?.message);
      onHide();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AnimatedLoader isLoading={isLoading} />
      <Modal show={show} size="lg" centered>
        <Modal.Body>
          <div className="modal__wrapper">
            <div className="inner__modal">
              <div className="team__modal edit-profile__modal">
                <button type="button" onClick={onHide} className="close-btn">
                  <img src="/img/closemodal.svg" alt="close modal" />
                </button>

                <div className="modal__info">
                  <div className="modal__info--main d-flex justify-content-between align-items-center">
                    <h2>Add Member(s)</h2>
                  </div>

                  <div className="members-table-wrapper">
                    <table className="members-table">
                      <thead>
                        <tr>
                          <th>Email</th>
                          <th>Weekly Order Limit</th>
                          <th>No Limit Applied</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {members.map((member, index) => (
                          <tr key={index}>
                            <td>
                              <input
                                type="email"
                                className="email-input"
                                value={member.email}
                                placeholder="user@gmail.com"
                                onChange={(e) => handleChange(index, "email", e.target.value)}
                              />
                              {errors[index] && (
                                <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                                  {errors[index]}
                                </div>
                              )}
                            </td>
                            <td>
                              <div className="limit-input-wrapper">
                                <input
                                  type="number"
                                  // min="0"
                                  className="limit-input"
                                  value={member.join_limit}
                                  placeholder="0"
                                  onChange={(e) =>
                                    handleChange(index, "join_limit", e.target.value)
                                  }
                                />
                                <span className="limit-text">times / week</span>
                              </div>
                            </td>
                            <td className="limits">
                              <input
                                type="checkbox"
                                checked={member.no_limit}
                                onChange={(e) => handleChange(index, "no_limit", e.target.checked)}
                              />
                            </td>
                            <td className="trash">
                              {members.length > 1 && (
                                <Trash2
                                  size={20}
                                  strokeWidth={2}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleDeleteRow(index)}
                                />
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="buttons">
                    <button type="button" className="add-row-btn" onClick={handleAddRow}>
                      <Plus size={20} />
                    </button>
                    <button type="button" className="modal-setting__save-btn"
                      onClick={handleSaveMembers}
                    >
                      Save Members
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalManageMembersSettings;
